module.exports = __webpack_public_path__ + "static/media/presentation.1fa16b68.png";